import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Patient } from '@models/patient';
import { Gender } from '../../../constants/gender';
import { IndependentLifeLevel } from '../../../constants/independentLifeLevel';
import { PatientCareLevel } from '../../../constants/careLevel';

type Props = {
  /** 合計スコア（pt）。 */
  score: number;
  /** 評価日。 */
  evaluatedAt: string;
  /** 患者。ゲストモード（患者なし）のときは渡さない。 */
  patient?: Patient;
  /** 自立度・介護度も表示するか。PDF2ページ目の見出しでは省く。 */
  showCareLevel?: boolean;
};

/**
 * 評価結果のスコア・属性情報・評価日の見出し。
 * 画面（1ページ目）の表示と、PDF2ページ目の先頭に出す見出しで共有する。
 * 中央揃えのため縦のFlexで包んで返す。
 */
export default function OhatResultHeading(props: Props) {
  const { score, evaluatedAt, patient, showCareLevel = false } = props;
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const lifeLevel = patient
    ? IndependentLifeLevel.getByKey(patient.independentLifeLevel)
    : IndependentLifeLevel.none;
  const careLevel = patient
    ? PatientCareLevel.getByKey(patient.careLevel)
    : PatientCareLevel.none;

  return (
    <Flex vertical gap={0} justify="center">
      <Typography.Text
        style={{
          fontSize: 30,
          fontWeight: 400,
          color: '#03007E',
          textAlign: 'center',
        }}
      >{`${t('ohat.score')}: ${score}pt`}</Typography.Text>
      {patient && (
        <>
          <Typography.Text style={{ fontSize: 22, textAlign: 'center' }}>
            {patient.age
              ? `${patient.name}(${patient.age}) ${Gender.getByKey(
                  patient.gender,
                ).getLabel(lang)}`
              : `${patient.name} ${Gender.getByKey(patient.gender).getLabel(
                  lang,
                )}`}
          </Typography.Text>
          {showCareLevel && (
            <Typography.Text style={{ fontSize: 16, textAlign: 'center' }}>
              {`${
                lifeLevel === IndependentLifeLevel.none
                  ? ''
                  : lifeLevel.getLabel(lang)
              } ${
                careLevel === PatientCareLevel.none
                  ? ''
                  : careLevel.getLabel(lang)
              }`}
            </Typography.Text>
          )}
        </>
      )}
      {/* 評価日は印刷でも読めるよう大きめ・通常の文字色にする。 */}
      <Typography.Text
        style={{ fontSize: 18, textAlign: 'center' }}
      >{`${t('ohat.evaluatedAt')} ${evaluatedAt}`}</Typography.Text>
    </Flex>
  );
}
